export default {
  namespaced: true,

  getters: {
    elements: (state, getters, rootState, rootGetters) => (element, parentModule) => {
      let components = rootGetters['layoutColumnModule/elements'](element, parentModule).components
      return Object.prototype.hasOwnProperty.call(element, 'component') ? components[element.component] : components
    },
    index: (state, getters) => (element, id, parentModule) => getters.elements(element, parentModule).findIndex(component => component.id == id),
    id: (state, getters) => (element, id = 'id', parentModule) => getters.elements(element, parentModule)[id],
    classes: (state, getters) => (element, classes = 'classes', parentModule) => getters.elements(element, parentModule)[classes],
    styles: (state, getters) => (element, styles = 'styles', parentModule) => getters.elements(element, parentModule)[styles],
    content: (state, getters) => (element, parentModule) => getters.elements(element, parentModule).content,
    name: (state, getters) => (element, parentModule) => getters.elements(element, parentModule).name,
    assets: (state, getters) => (element, parentModule) => getters.elements(element, parentModule).assets,
    background: (state, getters) => (element, parentModule) => getters.elements(element, parentModule).background,
    rows: (state, getters) => element => getters.elements(element).content.tabs[element.componentSection].content.rows,
    properties: (state, getters) => (element, parentModule) => getters.elements(element, parentModule).properties
  },
  actions: {
    removeFromArray({commit}, payload) {
      payload = {...payload, module: 'layoutComponentModule'}
      commit('actionsModule/removeFromArray', payload, {root: true})
    },
    addToArray({commit}, payload) {
      payload = {...payload, module: 'layoutComponentModule'}
      commit('actionsModule/addToArray', payload, {root: true})
    },
    addToObject({commit}, payload) {
      payload = {...payload, module: 'layoutComponentModule'}
      commit('actionsModule/addToObject', payload, {root: true})
    },
    updateOrder({commit}, payload) {
      payload = {...payload, module: 'layoutComponentModule'}
      commit('actionsModule/updateElementsOrder', payload, {root: true})
    },
  }
}
